/** @format */

import { Alert, Box, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header/Header";

export default function Layout({ children, timeout }) {
  const [open, setOpen] = useState(false);
  const [inactiveEventMessage, setInactiveEventMessage] = useState("");
  const isMobile = useMediaQuery("(max-width:768px)");
  const location = useLocation();

  useEffect(() => {
    const message = localStorage.getItem("eventInactiveMessage");
    if (message) {
      setInactiveEventMessage(message);
    }
  }, [location.pathname]);

  const handleCloseInactiveEventMessage = () => {
    setInactiveEventMessage("");
    localStorage.removeItem("eventInactiveMessage");
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Header
        open={open}
        handleDrawerOpen={handleDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        timeout={timeout}
      />
      {inactiveEventMessage && (
        <Box sx={{ px: 2, pt: 2 }}>
          <Alert severity="warning" onClose={handleCloseInactiveEventMessage}>
            {inactiveEventMessage}
          </Alert>
        </Box>
      )}
      <Box
        component="main"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "top",
          marginTop: "5vh",
          paddingTop: "80px",
          width: "100%",
          height: "100vh",
          marginLeft: isMobile ? "0" : "00px",
          overflowX: "hidden",
          paddingBottom: "16px",
        }}
      >
        {children}
      </Box>
    </>
  );
}
